/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as errors from "../../../../errors/index";
export class NotFoundError extends errors.FlatfileError {
    constructor(body, rawResponse) {
        super({
            message: "NotFoundError",
            statusCode: 404,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
